import { useContext, useState } from "react";
import { YearContext, AuthContext } from "../../context/context";
import GoalMetricCard from "./CardGoalMetric";
import { TbEdit } from "react-icons/tb";
import GoalMetricFavCard from "./CardGoalMetricFav";
import animation from "../../Animations/goal-animation.json";
import Popup from "../Elements/Popup";
import { updateGoalFavourite } from "../../api";
import { useLanguage } from "../../context/LanguageContext";
import Toast from "../Elements/Toast";

const GoalMetricsCards = () => {
  const { selectedYear } = useContext(YearContext);
  const { userData, setUserData } = useContext(AuthContext);
  const { copy } = useLanguage();

  const [popupType, setPopupType] = useState(null);
  const [selectedGoal, setSelectedGoal] = useState(null);
  const [toast, setToast] = useState({ message: "", type: "success" });

  const openPopup = (type) => {
    if (type === "goal-fav-edit") {
      const currentFavourite = filteredData.find((goal) => goal.favourite);
      setSelectedGoal(currentFavourite?.id || null);
    }
    setPopupType(type);
  };

  const closePopup = () => setPopupType(null);

  const goals = Array.isArray(userData?.goals) ? userData.goals : [];
  const filteredData = selectedYear
    ? goals.filter((goal) => goal.year === selectedYear)
    : goals;

  const favouriteGoal = filteredData.find((goal) => goal.favourite);
  const totalGoals = filteredData.length;

  const completedGoals = filteredData.filter((goal) => {
    const goalMilestones = userData.milestones.filter(
      (m) => m.goal_id === goal.id
    );
    return (
      goalMilestones.length > 0 &&
      goalMilestones.every((m) => m.status === true)
    );
  }).length;

  const inProcessGoals = filteredData.filter((goal) => {
    const goalMilestones = userData.milestones.filter(
      (m) => m.goal_id === goal.id
    );
    return (
      goalMilestones.length > 0 &&
      goalMilestones.some((m) => m.status === true) &&
      !goalMilestones.every((m) => m.status === true)
    );
  }).length;

  const favouriteDropdown = () => [
    {
      text: copy.dropdown.edit,
      onClick: () => openPopup("goal-fav-edit"),
      icon: <TbEdit />,
    },
  ];

  const handleGoalSelection = (goalId) => {
    setSelectedGoal(goalId);
  };

  const handleEditGoalFav = async () => {
    if (!selectedGoal) {
      setToast({ message: "No goal selected.", type: "error" });
      return;
    }

    try {
      await updateGoalFavourite(selectedGoal, true);

      const updatedGoals = userData.goals.map((goal) =>
        goal.year === selectedYear
          ? { ...goal, favourite: goal.id === selectedGoal }
          : goal
      );
      setUserData({
        ...userData,
        goals: updatedGoals,
      });

      setToast({
        message: "Favourite goal updated successfully.",
        type: "success",
      });
      closePopup();
    } catch (error) {
      console.error("Error updating goal favourite:", error.message);
      setToast({ message: "Failed to update favourite goal.", type: "error" });
    }
  };

  return (
    <div className="flex flex-col sm:flex-row gap-2 mb-10">
      {toast.message && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast({ message: "", type: "success" })}
        />
      )}

      <GoalMetricFavCard
        favouriteGoal={favouriteGoal}
        selectedYear={selectedYear}
        dropdown={favouriteDropdown}
        lottieAnimation={animation}
      />
      <div className="grid grid-cols-3 gap-2 justify-between">
        <GoalMetricCard
          title={copy.metrics.total}
          number={totalGoals}
          description={copy.metrics.total_desc.replace('{year}', selectedYear)}
        />
        <GoalMetricCard
          title={copy.metrics.progress}
          number={inProcessGoals}
          description={copy.metrics.progress_desc.replace('{year}', selectedYear)}
        />
        <GoalMetricCard
          title={copy.metrics.completed}
          number={completedGoals}
          description={copy.metrics.completed_desc.replace('{year}', selectedYear)}
        />
      </div>

      <Popup
        isOpen={popupType === "goal-fav-edit"}
        onClose={closePopup}
        title={`${copy.metrics.popup.edit_title} ${selectedYear}`}
        description={copy.metrics.popup.edit_description}
        buttonSecondaryCTA={copy.dropdown.cancel}
        onClickSecondaryLink={closePopup}
        buttonPrimaryCTA={copy.dropdown.save}
        onClickPrimaryLink={handleEditGoalFav}
      >
        <div className="mt-4">
          {filteredData.map((goal) => (
            <div key={goal.id} className="flex items-center gap-2 ">
              <input
                type="radio"
                id={`goal-${goal.id}`}
                name="bigThing"
                value={goal.id}
                checked={selectedGoal === goal.id}
                onChange={() => handleGoalSelection(goal.id)}
                className="cursor-pointer"
              />
              <label htmlFor={`goal-${goal.id}`} className="text-md">
                {goal.title}
              </label>
            </div>
          ))}
        </div>
      </Popup>
    </div>
  );
};

export default GoalMetricsCards;
